export const GET_ROLES = "GET_ROLES";
export const GET_ROLES_START = "GET_ROLES_START";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAIL = "GET_ROLES_FAIL";
